import { useState } from 'react';

export default function WhatWeBuild() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const categories = [
    {
      title: 'Apartment Buildings',
      expanding: false,
      link: '/services',
      image: 'https://public.readdy.ai/ai/img_res/9e11fa09ce459faee0d11696a4912c2b.jpg',
    },
    {
      title: 'Apartment Complexes',
      expanding: false,
      link: '/services',
      image: 'https://readdy.ai/api/search-image?query=large%20scale%20multifamily%20apartment%20complex%20with%20multiple%20buildings%2C%20landscaped%20courtyards%20and%20amenities%2C%20aerial%20view%20showing%20professional%20development%2C%20warm%20natural%20lighting%2C%20premium%20residential%20community%20design&width=800&height=600&seq=apartment-complex-1&orientation=landscape',
    },
    {
      title: 'Memory Care Facilities',
      expanding: true,
      link: '/senior-living-healthcare-construction',
      image: 'https://readdy.ai/api/search-image?query=modern%20memory%20care%20facility%20interior%20with%20warm%20welcoming%20design%2C%20comfortable%20common%20areas%20and%20safe%20accessible%20spaces%2C%20professional%20healthcare%20architecture%20photography%2C%20natural%20lighting%20and%20calming%20colors%2C%20dignified%20senior%20living%20environment&width=800&height=600&seq=memory-care-1&orientation=landscape',
    },
    {
      title: 'Nursing Homes',
      expanding: true,
      link: '/senior-living-healthcare-construction',
      image: 'https://readdy.ai/api/search-image?query=contemporary%20nursing%20home%20facility%20with%20professional%20medical%20grade%20finishes%2C%20clean%20modern%20healthcare%20interior%20design%2C%20comfortable%20patient%20rooms%20and%20common%20areas%2C%20warm%20inviting%20atmosphere%20with%20natural%20light%2C%20quality%20senior%20care%20environment&width=800&height=600&seq=nursing-home-1&orientation=landscape',
    },
    {
      title: 'Assisted Living Facilities',
      expanding: true,
      link: '/senior-living-healthcare-construction',
      image: 'https://readdy.ai/api/search-image?query=upscale%20assisted%20living%20facility%20with%20elegant%20residential%20style%20interiors%2C%20comfortable%20common%20spaces%20and%20dining%20areas%2C%20professional%20senior%20living%20photography%2C%20warm%20welcoming%20design%20with%20natural%20materials%2C%20premium%20care%20environment&width=800&height=600&seq=assisted-living-1&orientation=landscape',
    },
    {
      title: 'Retirement Communities',
      expanding: true,
      link: '/senior-living-healthcare-construction',
      image: 'https://readdy.ai/api/search-image?query=luxury%20retirement%20community%20campus%20with%20beautiful%20landscaping%20and%20modern%20buildings%2C%20active%20senior%20living%20amenities%20and%20gathering%20spaces%2C%20professional%20architectural%20photography%2C%20warm%20inviting%20atmosphere%2C%20resort%20style%20senior%20living%20design&width=800&height=600&seq=retirement-community-1&orientation=landscape',
    },
  ];

  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-4">
            What We Build
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Specializing in multifamily construction and senior living renovations across the Mid-Atlantic and Southeast.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <a
              key={index}
              href={category.link}
              className="relative h-80 rounded-lg overflow-hidden cursor-pointer group block"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Image */}
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              {/* Overlay */}
              <div
                className={`absolute inset-0 transition-all duration-300 ${
                  hoveredIndex === index
                    ? 'bg-[#C5A55A]/90'
                    : 'bg-gradient-to-t from-black/80 via-black/40 to-transparent'
                }`}
              ></div>

              {/* Expanding Badge */}
              {category.expanding && (
                <div className="absolute top-3 right-3 z-10 bg-[#C5A55A] text-[#1A1A1A] text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-md">
                  Expanding
                </div>
              )}

              {/* Title */}
              <div className="absolute inset-0 flex items-center justify-center p-6">
                <h3 className="text-2xl lg:text-3xl font-bold text-white text-center">
                  {category.title}
                </h3>
              </div>

              {/* Hover Icon */}
              {hoveredIndex === index && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white text-5xl"></i>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}